import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import LocalStorage from '../Services/LocalStorage'
import Api from '../Services/Api'
import { percorsoConsentito } from '../Utils/sezioniAccesso'
import i18n from '../i18n'
import LoadError from './LoadError'
import Loader from '../Library/Tools/Loader'
import { isSessionExpiredResponse } from '../Utils/sessionResponse'

let sezioniPromise = null
export const caricaSezioni = () => {
  sezioniPromise = sezioniPromise || Api.get('/sezioni').then(res => (res.ok ? res.data : null)).catch(() => null)
  return sezioniPromise
}

const ProtectedRoute = ({ children }) => {
  const jwt = LocalStorage.get('jwt')
  const user = LocalStorage.get('user')
  const { pathname } = useLocation()
  const [gate, setGate] = useState(null)
  const [error, setError] = useState(false)
  const [expired, setExpired] = useState(false)
  const [attempt, setAttempt] = useState(0)

  useEffect(() => {
    const onExpired = () => setExpired(true)
    const onSession = e => {
      if (e.detail?.key !== 'jwt') return
      setExpired(!LocalStorage.get('jwt'))
      setAttempt(n => n + 1)
    }
    window.addEventListener('ems-session-expired', onExpired)
    window.addEventListener('ems-session-changed', onSession)
    return () => {
      window.removeEventListener('ems-session-expired', onExpired)
      window.removeEventListener('ems-session-changed', onSession)
    }
  }, [])

  useEffect(() => {
    if (!jwt || !user) return
    let active = true
    setError(false)
    Promise.all([caricaSezioni(), Api.get('/users/me')]).then(([sections, res]) => {
      if (!active) return
      if (!sections) sezioniPromise = null
      if (isSessionExpiredResponse(res)) { setExpired(true); return }
      if (!res.ok || !sections || !Array.isArray(sections)) { setError(true); return }
      if (LocalStorage.get('user')?._id !== user._id) return
      LocalStorage.set('user', res.data)
      setGate({ pathname, sections, user: res.data })
      setExpired(false)
    }).catch(() => { if (active) setError(true) })
    return () => { active = false }
  }, [pathname, attempt]) // eslint-disable-line react-hooks/exhaustive-deps

  if ((!jwt || !user) && !gate && !expired) return <Navigate to='/login' replace />
  const authorized = gate?.pathname === pathname
  if (authorized && !percorsoConsentito(pathname, gate.sections, gate.user.sezioni)) return <Navigate to='/home' replace />

  // Keep an authorized page mounted so an expired session does not destroy its draft.
  return (
    <>
      {expired && (
        <section role='alert' style={{ padding: '1rem', border: '1px solid currentColor', margin: '1rem' }}>
          <strong>{i18n.t('sessionExpired', { ns: 'common' })}</strong>
          <p>{i18n.t('sessionExpiredDraft', { ns: 'common' })}</p>
          <a href='/login' target='_blank' rel='noopener noreferrer'>{i18n.t('loginInNewTab', { ns: 'common' })}</a>
          {' '}
          <button type='button' onClick={() => setAttempt(n => n + 1)}>{i18n.t('retry', { ns: 'common' })}</button>
        </section>
      )}
      {!expired && error && <LoadError onRetry={() => setAttempt(n => n + 1)} onBack={() => window.location.assign('/home')} />}
      {!expired && !error && !authorized && <Loader loading />}
      {authorized && <div inert={expired || error ? '' : undefined} style={{ display: 'contents' }}>{children}</div>}
    </>
  )
}

export default ProtectedRoute
